import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fd;
`;
export const HeaderTitle = styled.div`
  padding: 1rem 2rem;

  height: fit-content;
  & > h1 {
    margin: 0;
    color: #123559;
    text-align: start;
  }
  & > p {
    margin: 0;
    color: #808080;
    text-align: start;
    font-weight: 200;
  }
`;

export const ContainerContent = styled.div`
  display: flex;
  height: 100%;
`;

export const ContainerTimeline = styled.div`
  position: relative;
  min-width: 680px;
  height: 100%;
  padding-right: 1rem;
`;
export const ContainerCard = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0rem;
  bottom: 0rem;
  right: 0rem;
  width: 420px;
  height: 100vh;
`;

export const ContainerHeaderCard = styled.div`
  width: 100%;
  display: flex;
`;

export const AvatarProfile = styled.img`
  width: 5rem;
  height: 5rem;
  border-radius: 3rem;
`;
export const ContainerDetailProfile = styled.div`
  padding-left: 1rem;
  align-self: center;
  & > h2 {
    margin: 0;
    color: #123559;
    text-align: start;
  }
  & > p {
    margin: 0;
    color: #808080;
    text-align: start;
    font-weight: 200;
  }
`;
export const TitleDetail = styled.p`
  color: #123559;
  text-align: start;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;
export const Detail = styled.p`
  color: #808080;
  font-weight: 300;
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  background-color: #123559;
  border: none;
  color: #fff;
  align-self: center;
`;

export const Textarea = styled.textarea`
  border-radius: 1rem;
  background-color: #f8f9fd;
  width: 100%;
  border: none;
  padding: 1rem;
  flex: 1;
  margin-bottom: 1rem;
  height: auto;
`;

export const ContainerDate = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  widows: fit-content;
  height: 100%;
  flex-direction: column;
  z-index: 0;
  & > p {
    width: fit-content;
    margin: 0;
  }

  & :first-child {
    color: #aaa;
    font-weight: 200;
  }

  & > div {
    width: 1px;
    flex: 1;
    background-color: #ddd9;
  }
`;

export const ScrollContainer = styled.div`
  flex: 2;
  padding: 2rem;
  max-width: calc(100vw - 400px);

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  overflow-x: scroll;
`;

export const ContainerBar = styled.div`
  z-index: 99;
  display: flex;
  flex-direction: column;
  padding-top: 5rem;
  & > * {
    z-index: 99;
  }
`;

interface IBarProps {
  background?: string;
}

export const BarContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border-radius: 1rem;
  margin: 0.5rem;
  cursor: pointer;
  background: linear-gradient(270deg, #5646ad 0%, #4a68af 100%);
  ${({ background }: IBarProps) => background && `background: ${background};`}
`;

export const TextDateBar = styled.p`
  color: #ffffff;
  margin: 0;
`;
